import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-airbnb-button',
  templateUrl: './airbnb-button.component.html',
  styleUrls: ['./airbnb-button.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({opacity: 0}),
        animate(500, style({opacity: 1}))
      ]),
      transition(':leave', [
        animate(500, style({opacity: 0}))
      ])
    ])
  ]
})
export class AirbnbButtonComponent implements OnInit {

  @Input() airbnbLink: string;
  showListing: boolean;

  constructor() { }

  ngOnInit() {
  }

}
